module.exports = __webpack_public_path__ + "img/img2.d8bb81f2.png";